var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.12,
    fillRule: "evenodd",
    d: "M0 16.676c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16-16-7.164-16-16",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.546 10.558c-.024-1.069-.788-1.882-2.028-1.882s-2.051.813-2.051 1.882c0 1.046.787 1.883 2.004 1.883h.023c1.264 0 2.052-.837 2.052-1.883M11.307 13.928H7.681v10.894h3.626zM20.209 13.672c2.386 0 4.175 1.557 4.175 4.904v6.246h-3.626v-5.828c0-1.464-.525-2.463-1.838-2.463-1.001 0-1.598.673-1.86 1.324-.096.233-.12.558-.12.883v6.085h-3.626s.048-9.873 0-10.895h3.627v1.543c.48-.742 1.343-1.8 3.268-1.8"
  })));
};
export default SvgLinkedin;